import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../tikexModule/hooks/useAuth'
import useLocalStorage from '../../../tikexModule/hooks/useLocalStorageTX'
import slugify from '../../../tikexModule/utils/slugify'
import Input from '../../../tikexModule/components/inputs/Input'
import Select from '../../../tikexModule/components/inputs/Select'
import Switch from '../../../tikexModule/components/inputs/Switch'
import SwitchBase from '../../../tikexModule/components/inputs/SwitchBase'
import { SzamlazzhuVatKey } from '../../../tikexModule/Types/Tikex'
import ImageUpload from '../../../tikexModule/components/ImageUpload'
import { startFinalInvoicingSzamlazzHu } from '../../../tikexModule/services/startFinalInvoicingSzamlazzHu'
import randomString from '../../../tikexModule/utils/randomString'
import { missingFieldToRunEvent } from '../../../tikexModule/checkEnableSale'

export default function GiveawaysEditorContent({
	children,
}: {
	children?: React.ReactNode
}) {
	const auth = useAuth()
	const [organizationShortId, setSelectedOrganizationShortId] =
		useLocalStorage<string>('teamIdDashboard', '')
	const [newProgramId, setNewProgramId] = useState<string>('')
	const [eventId, setEventId] = useLocalStorage<string>(
		'productIdDashboard',
		''
	)
	const o = auth.userDTO?.teams?.[organizationShortId]
	const event = o?.products?.[eventId]
	const pr = event
	//const missingField = missingFieldToRunEvent(event, o)
	const passTypeOptions = Object.entries(o?.passTypes ?? {}).map(
		([passTypeId, passType]) => {
			return {
				value: passTypeId,
				label: `Ár: ${passType.price} - Kapacitás: ${passType.capacity} - Lejárat: ${passType.expirationDays}`,
			}
		}
	)
	const missingField = missingFieldToRunEvent(event)

	useEffect(() => {
		if (eventId) {
			setNewProgramId(eventId)
		}
	}, [eventId])

	if (auth.userDTO) {
		return (
			<div className="wrap">
				<table className="form-table" role="presentation">
					<tbody>
						<tr>
							<th scope="row">test</th>
							<td>test</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	} else if (auth.isUpdateUserDTOCompleted) {
		return <>{children}</>
	} else {
		return <></>
	}
}
